import * as types from './actionTypes';
import axios from 'axios';
import { getHeader, getMessageByErrorStatus } from '../helper';
import { setGlobalErrors } from "./globalErrorActions";

export function getCurrentUserSuccess(currentUser, update) {
    return {
        type: types.CURRENT_USER_SUCCESS,
        currentUser,
        update
    };
}

export function getCurrentUserError(message, status) {
    return {
        type: types.CURRENT_USER_FAILED,
        message,
        errorStatus: status,
    };
}

function getCurrentUserRequest(token, update) {
    return {
        type: types.CURRENT_USER_REQUEST,
        token,
        update
    }
}

export function getCurrentUser(token, callback, update = false) {
    return function (dispatch) {

        dispatch(getCurrentUserRequest(token, update));
        dispatch(setGlobalErrors('session', {}));

        return axios.get(`${window.siteUrl}/api/v1/user/current/`, {
            headers: getHeader()
        })
        .then(response => {
            dispatch(getCurrentUserSuccess(response.data, update));
            if(callback && typeof callback === 'function') callback();
        })
        .catch(function (error) {
            let err = error.response || {};
            let errData = err.data || {};
            
            let errorText = getMessageByErrorStatus(errData.status);
            // console.log(err, errData, errorText)
            dispatch(getCurrentUserError(
                errData.detail || errorText,
                errData.status
            ));
            // dispatch(setGlobalErrors('session', {status: err.status, error: errorText}));
        });
    };
}


function receiveLogin(token) {
    return {
        type: types.LOGIN_SUCCESS,
        id_token: token
    }
}

function requestLogin(user) {
    return {
        type: types.LOGIN_REQUEST,
        user
    }
}

function loginError(messages) {
    return {
        type: types.LOGIN_FAILURE,
        messages
    }
}

export function loginUser(data, redirect, callback) {
    return function (dispatch) {

        dispatch(requestLogin(data));
        dispatch(setGlobalErrors('session', {}));

        return axios.post(`${window.siteUrl}/api/v1/token-auth/`, {
            username: data.username,
            password: data.password
        })
        .then(function (response) {
            localStorage.setItem('id_token', response.data.token);
            dispatch(receiveLogin(response.data.token));

            if (callback)
                callback(response.data.token)

            if (redirect && typeof redirect === 'function') {
                redirect();
            }
        })//.bind(this)
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                
                if (err.status === 500) {
                    dispatch(loginError({ non_field_errors: ['Ошибка сервера'] }));
                }
                else {
                    dispatch(loginError(err.data));
                }

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('session', {status: err.status, error: errorText}));
            }
        });
    }
}




export function loginFBUser(params, redirect, callback) {
    return function (dispatch) {

        dispatch(requestLogin(params));
        dispatch(setGlobalErrors('session', {}));

        return axios.post(
            `${window.siteUrl}/api/v1/auth/convert-token/`,
            params
        )
        .then(function (response) {
            localStorage.setItem('id_token', response.data.access_token);
            dispatch(receiveLogin(response.data.access_token));

            if(callback)
                callback(response.data.access_token);

            if(redirect) redirect();
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                
                dispatch(loginError(err.data));

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('session', {status: err.status, error: errorText}));
            }
        });
    }
}


export function logoutRequest() {
    return {
        type: types.LOGOUT_REQUEST
    };
}

export function logoutSuccess() {
    return {
        type: types.LOGOUT_RECEIVE
    };
}

export function logoutError(payload) {
    return {
        type: types.LOGOUT_FAILURE,
        payload
    };
}

export function logout(user, history, callback) {
    return function (dispatch) {
        dispatch(logoutRequest());

        return axios.post(
            `${window.siteUrl}/api/v1/user/${user.id}/logout/`,
            {},
            {
                headers: getHeader()
            }
        )
        .then(response => { 
            localStorage.removeItem('id_token');
            dispatch(logoutSuccess());
            dispatch(resetAllInfo());
            if(callback) callback(localStorage.id_token);

            setTimeout(() => {
                history.replace('/')
            },0);
        })
        .catch(error => {
            dispatch(logoutError(error.response.data || {}));
        });
    };
}



export function resetAllInfo() {
    return {
        type: types.RESET_ALL_INFO,
    };
}



function requestCreateUser(params) {
    return {
        type: types.CREATE_USER_REQUEST,
        params
    }
}

function receiveCreateUser(data) {
    return {
        type: types.CREATE_USER_SUCCESS,
        data
    }
}

function errorCreateUser(messages) {
    return {
        type: types.CREATE_USER_FAILED,
        messages
    }
}

export function clearErrorsCreateUser() {
    return {
        type: types.CREATE_USER_CLEAR_MESSAGES,
    }
}

export function createUser(params, callback) {
    return function (dispatch) {

        dispatch(requestCreateUser(params));
        dispatch(setGlobalErrors('session', {}));

        return axios.post(`${window.siteUrl}/api/v1/user/`, params)
            .then(function (response) {
                dispatch(receiveCreateUser(response.data));

                if (callback) {
                    callback(response.data);
                }
            })
            .catch(function (error) {
                if (error.response) {
                    let err = error.response;
                    console.error("createUser error", err.data, err.status, err.headers);
                    dispatch(errorCreateUser(err.data));

                    let errorText = getMessageByErrorStatus(err.status);
                    dispatch(setGlobalErrors('session', {status: err.status, error: errorText}));
                }
            });
    }
}


function createCompanyRequest(params) {
    return {
        type: types.CREATE_COMPANY_REQUEST,
        params
    }
}

function createCompanyReceive(data) {
    return {
        type: types.CREATE_COMPANY_SUCCESS,
        payload: data
    }
}

function createCompanyError(messages) {
    return {
        type: types.CREATE_COMPANY_FAILED,
        payload: messages
    }
}

export function createCompany(params, config, callback) {
    return function (dispatch) {

        dispatch(createCompanyRequest(params));
        dispatch(setGlobalErrors('company', {}));

        return axios.post(`${window.siteUrl}/api/v1/company/`, params, config)
            .then(function (response) {
                // console.log("createCompany success", response.data);

                dispatch(createCompanyReceive(response.data));

                callback(response.data);
            })
            .catch(function (error) {
                if (error.response) {
                    let err = error.response;
                    console.error("createCompany error", err.data, err.status, err.headers);
                    dispatch(createCompanyError(err.data));

                    let errorText = getMessageByErrorStatus(err.status);
                    dispatch(setGlobalErrors('company', {status: err.status, error: errorText}));
                }
            });
    }
}


function createUserVerificationRequest(code) {
    return {
        type: types.CREATE_USER_VERIFICATION_REQUEST,
        code
    }
}

function createUserVerificationReceive(data) {
    return {
        type: types.CREATE_USER_VERIFICATION_SUCCESS,
        data
    }
}

function createUserVerificationReceiveError(messages) {
    return {
        type: types.CREATE_USER_VERIFICATION_FAILED,
        messages
    }
}

export function createUserVerification(ID, params, callback) {
    return function (dispatch) {

        dispatch(createUserVerificationRequest(params));
        dispatch(setGlobalErrors('session', {}));

        return axios.post(`${window.siteUrl}/api/v1/user/${ID}/confirm_phone/`, params)
            .then(function (response) {
                //console.log("createUserVerification success", response.data);

                dispatch(createUserVerificationReceive(response.data));

                if (callback) callback();

            })
            .catch(function (error) {
                if (error.response) {
                    let err = error.response;
                    console.error("createUserVerification error", err.data, err.status, err.headers);
                    dispatch(createUserVerificationReceiveError(err.data));

                    let errorText = getMessageByErrorStatus(err.status);
                    dispatch(setGlobalErrors('session', {status: err.status, error: errorText}));
                }
            });
    }
}



function phoneConfirmationRequest() {
    return {
        type: types.PHONE_CONFIRMATION_REQUEST,
    }
}

function phoneConfirmationReceive(data) {
    return {
        type: types.PHONE_CONFIRMATION_SUCCESS,
        data
    }
}

function phoneConfirmationError(messages) {
    return {
        type: types.PHONE_CONFIRMATION_FAILED,
        messages
    }
}

export function phoneConfirmation(params, callback) {
    return function (dispatch) {

        dispatch(phoneConfirmationRequest());
        dispatch(setGlobalErrors('session', {}));

        return axios.get(`${window.siteUrl}/api/v1/get_phone_confirmation_key/?phone=${params.phone}&email=${params.email}`)
        .then(function (response) {
            //console.log("phoneConfirmationReceive success", response.data);

            dispatch(phoneConfirmationReceive(response.data));

            if (callback) callback();
        })
        .catch(function (error) {
            console.error("createUserVerification error", error);
            dispatch(phoneConfirmationError(error.response.data));

            let errorText = getMessageByErrorStatus(error.response.status);
            dispatch(setGlobalErrors('session', {status: error.response.status, error: errorText}));
        });
    }
}



function requestCreateUser2() {
    return {
        type: types.CREATE_USER_REQUEST,
    }
}

function receiveCreateUser2(data) {
    return {
        type: types.CREATE_USER_SUCCESS,
        data
    }
}

function errorCreateUser2(messages) {
    return {
        type: types.CREATE_USER_FAILED,
        messages
    }
}

export function createUser2(params, callback) {
    return function (dispatch) {

        dispatch(requestCreateUser2());
        dispatch(setGlobalErrors('session', {}));

        return axios.post(`${window.siteUrl}/api/v1/user/`, params)
        .then(function (response) {
            // console.log("createUser success", response.data);

            dispatch(receiveCreateUser2(response.data));

            if (callback) {
                callback(response.data);
            }
        })
        .catch(function (error) {
            dispatch(errorCreateUser2(error.response.data));

            let errorText = getMessageByErrorStatus(error.response.status);
            dispatch(setGlobalErrors('session', {status: error.response.status, error: errorText}));
        });
    }
}


export function writeOffMoneyUser(data) {
    return {
        type: types.WRITE_OFF_MONEY_USER,
        data
    }
}

export function addMoneyUser(data) {
    return {
        type: types.ADD_MONEY_USER,
        data
    }
}

export function updateUserData(payload) {
    return {
        type: types.UPDATE_CURRENT_USER_DATA,
        payload
    }
}


export function getUpdateUserDataRequest() {
    return {
        type: types.UPDATE_USER_DATA_REQUEST,
    }
}

export function getUpdateUserDataSuccess(currentUser) {
    return {
        type: types.UPDATE_USER_DATA_SUCCESS,
        currentUser
    };
}

export function getUpdateUserDataError(message) {
    return {
        type: types.UPDATE_USER_DATA_FAILED,
        message
    };
}

export function getUpdateUserData(token, callback) {
    return function (dispatch) {

        dispatch(getUpdateUserDataRequest());
        dispatch(setGlobalErrors('session', {}));

        return axios.get(`${window.siteUrl}/api/v1/user/current/`, {
            headers: getHeader()
        })
        .then(response => {
            // console.log("getUpdateUserDataSuccess", response.data)
            if (callback && typeof callback === 'function') callback();

            return dispatch(getUpdateUserDataSuccess(response.data))
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                dispatch(getUpdateUserDataError(err.data.detail));

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('session', {status: err.status, error: errorText}));
            }
        });
    };
}


// WEBPACK FOOTER //
// ./src/actions/session.js